import { useQuery } from '@tanstack/react-query';
import { api } from '../../core/client';
import type { BatchRecord, BatchStage } from './production.types';

const PROD = '/users/v1/production';
const KEY = ['production'] as const;

/**
 * The cross-site batch list — the ONLY production read left (see
 * `production.types.ts` for why).
 *
 * `enabled` exists so a console with one site in scope can turn it off and read
 * that site directly instead (R-205 P2) — two lists of the same batches, one of
 * which is a mirror, is a waste and a race.
 */
export function useBatches(stage: BatchStage | '', enabled = true) {
  return useQuery({
    queryKey: [...KEY, 'batches', stage],
    queryFn: () => api.get<BatchRecord[]>(`${PROD}/batches?stage=${stage}`),
    refetchInterval: 60_000,
    enabled,
  });
}
